import React from 'react';
import styled from 'styled-components';
import { Select } from 'shared/components';
import { MobileAppProductCollectionDisplayType } from 'types/graphql';
import useHasMobileApp from 'src/utils/use-has-mobile-app';

type MobileAppDisplayTypeSelectProps = {
  value: MobileAppProductCollectionDisplayType;
  onChange: (value: MobileAppProductCollectionDisplayType) => void;
};

/** Mobile product layout control; only rendered when a mobile app is configured. */
export function AppDisplayTypeSelect({ value, onChange }: MobileAppDisplayTypeSelectProps): JSX.Element | null {
  const hasMobileApp = useHasMobileApp();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    onChange(event.target.value as MobileAppProductCollectionDisplayType);
  };

  if (!hasMobileApp) {
    return null;
  }

  return (
    <Container>
      <Label>MOBILE APP DISPLAY TYPE</Label>
      <Select fontSize='13px' height={45} onChange={handleChange} value={value} width='326px'>
        <option value={MobileAppProductCollectionDisplayType.scrollableRow}>Scrollable Row</option>
        <option value={MobileAppProductCollectionDisplayType.grid}>Grid</option>
        <option value={MobileAppProductCollectionDisplayType.heroCarousel}>Hero Carousel</option>
      </Select>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 10px;
`;

const Label = styled.div`
  display: block;
  font-size: 11px;
  font-weight: bold;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.grey[45]};
  padding-bottom: 10px;
`;
